<tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid" (ttReady)="gridReady.emit(grid)"></tt-grid>
